import { redirect } from "react-router-dom";

export async function loader({ request }) {
  const url = new URL(request.url);
  const pathname = url.pathname.endsWith("/") ? url.pathname.slice(0, -1) : url.pathname;
  if (pathname === "/cheap-flights") {
    return redirect(`/cheap-flights/ow/${window.SERVER_DATA.REACT_APP_DEFAULT_ORIGIN_IATA}`);
  }
  return null;
}
